import { render, staticRenderFns } from "./InternationalInvoiceHasBeenReviewed.vue?vue&type=template&id=064b934c&scoped=true"
import script from "./InternationalInvoiceHasBeenReviewed.vue?vue&type=script&lang=js"
export * from "./InternationalInvoiceHasBeenReviewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b934c",
  null
  
)

export default component.exports